import React from 'react';
function Domain({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        strokeLinecap="round"
        d="M9 7c0-1.333 1.286-4 3-4s3 2.667 3 4M9 17c0 1.333 1.286 4 3 4s3-2.667 3-4"
      />
      <path
        strokeLinecap="round"
        d="M5 7c.73-1.333 3.15-4 7-4s6.27 2.667 7 4M5 17c.73 1.333 3.15 4 7 4s6.27-2.667 7-4"
      />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M2 10l1.25 4 1.25-3.6L5.75 14 7 10M9 10l1.5 4 1.5-3.6 1.5 3.6 1.5-4M17 10l1.25 4 1.25-3.6 1.25 3.6L22 10"
      />
    </svg>
  );
}

export default Domain;
